export default "/* You can add global styles to this file, and also import other style files */\r\nbody {\r\n  background: transparent;\r\n}\r\n";